import React, { useContext } from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import sicunetMobile from "../../../../assets/images/mobileApplication/sicunet-mobile.png";
import sicunetCredential from "../../../../assets/images/mobileApplication/sicunet-credential.png";
import sicunetInstaller from "../../../../assets/images/mobileApplication/sicunet-installer.png";
import sicunetDirectory from "../../../../assets/images/mobileApplication/sicunet-directory.png";
import GooglePlayButton from "../../../../assets/svg/ContentView/GooglePlayButton";
import AppleStoreButton from "../../../../assets/svg/ContentView/AppleStoreButton;";
import DownloadSection from "../../../../lib/downloadSection";
import useSWR from "swr";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import SicunetMobile from "../../../../global/components/Icons/SicunetMobile";
import Credential from "../../../../global/components/Icons/Credential";
import Directory from "../../../../global/components/Icons/Directory";
import SicunetInstaller from "../../../../global/components/Icons/SicunetInstaller";

const PAGE_X = "px-6 lg:px-[120px]";

const AppStoreButtons = ({ playStoreLink, appStoreLink, align = "left" }) => (
  <div
    className={`flex flex-col gap-3 w-full ${
      align === "right" ? "items-end" : "items-start"
    }`}
  >
    <p className="text-[24px] font-normal font-['Poppins'] text-black leading-none">
      Download
    </p>
    <div
      className={`flex flex-row gap-1.5 flex-wrap ${
        align === "right" ? "justify-end" : "justify-start"
      }`}
    >
      {playStoreLink && (
        <a
          href={playStoreLink.trim()}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block shrink-0 hover:opacity-90 transition-opacity"
        >
          <GooglePlayButton />
        </a>
      )}
      {appStoreLink && (
        <a
          href={appStoreLink.trim()}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block shrink-0 hover:opacity-90 transition-opacity"
        >
          <AppleStoreButton />
        </a>
      )}
    </div>
  </div>
);

const AppSectionText = ({
  icon: Icon,
  title,
  description,
  playStoreLink,
  appStoreLink,
  textAlign,
}) => (
  <div
    className={`w-full max-w-[590px] flex flex-col gap-5 ${
      textAlign === "right" ? "text-right items-end" : "text-left items-start"
    }`}
  >
    <h3
      className={`text-[#171717] text-2xl font-medium font-['Inter'] leading-normal w-full flex items-center gap-2 ${
        textAlign === "right" ? "justify-end" : "justify-start"
      }`}
    >
      <Icon className="shrink-0" aria-hidden="true" />
      {title}
    </h3>
    <p className="text-base font-normal font-['Poppins'] leading-[26px] text-[#3b3b3b] w-full">
      {description}
    </p>
    <AppStoreButtons
      playStoreLink={playStoreLink}
      appStoreLink={appStoreLink}
      align={textAlign}
    />
  </div>
);

const sections = [
  {
    image: sicunetMobile,
    title: "Sicunet Mobile",
    icon: SicunetMobile,
    description:
      "Sicunet Smart Access Control Mobile App puts seamless access control at your fingertips. Effortlessly manage your premises with real-time event monitoring, door access control, and easy site connection setup—Remote or Local. Import site keys with a single click, navigate menus effortlessly, and add persons and credentials. Access live channels and tagged video with ease. Unlock doors with a tap! Whether on-site or remote, Sicunet ensures smooth and secure control of your environment—anytime, anywhere.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    imageMaxWidth: "435px",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=bd.sicunet.webapp",
    appStoreLink: "https://apps.apple.com/us/app/sicunet-mobile/id6738885137",
  },
  {
    image: sicunetCredential,
    title: "Sicunet Credential",
    icon: Credential,
    description:
      "Sicunet Installer is your go-to app for seamless Neptune 2.0 system setup and management through BLE. Whether you're configuring network settings, connecting to the cloud, managing licenses, or defining roles for nodes (Sever/Client) and controllers (Door/Elevator), this app has you covered. Additionally, it provides essential functionality like updating, rebooting, and restoring to default settings. Designed for efficiency and convenience, IP Installer ensures a smooth experience in setting up and maintaining your systems.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    imageMaxWidth: "435px",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=bd.sicunet.credential&pcampaignid=web_share",
    appStoreLink:
      "https://apps.apple.com/us/app/sicunet-credential/id6740619928",
  },
  {
    image: sicunetInstaller,
    title: "Sicunet Installer",
    icon: SicunetInstaller,
    description:
      "Sicunet Installer is your go-to app for seamless Neptune 2.0 system setup and management through BLE. Whether you're configuring network settings, connecting to the cloud, managing licenses, or defining roles for nodes (Sever/Client) and controllers (Door/Elevator), this app has you covered. Additionally, it provides essential functionality like updating, rebooting, and restoring to default settings. Designed for efficiency and convenience, IP Installer ensures a smooth experience in setting up and maintaining your systems.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    imageMaxWidth: "435px",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=bd.sicunet.sicunetbd_installer&pcampaignid=web_share",
    appStoreLink:
      "https://apps.apple.com/us/app/sicunet-installer/id6740024575",
  },
  {
    image: sicunetDirectory,
    title: "Sicunet Directory",
    icon: Directory,
    description:
      "Sicunet Softphone is your smart companion for managing intercom systems. Designed for seamless integration with Sicunet Intercom devices, the app offers a secure and convenient way to stay connected and control access remotely.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    imageMaxWidth: "435px",
    playStoreLink:
      "https://play.google.com/store/apps/details?id=bd.sicunet.sicunetbd_intercom&pcampaignid=web_share",
    appStoreLink:
      "https://apps.apple.com/us/app/sicunet-directory/id6742125280",
  },
];

export const MobileContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher
  );
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white w-full">
      <section
        className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[872px]">
          Smart Access Solutions | Mobile Apps
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[792px]">
          Seamless mobile apps for secure control, credential management, and
          system installation — all in one connected ecosystem.
        </p>
      </section>

      <div className="w-full bg-white pt-6">
        {sections.map((section) => (
          <SectionBlock
            key={section.title}
            image={section.image}
            imageLeft={section.imageLeft}
            imageBg={section.imageBg}
            textBg={section.textBg}
            sectionHeight="520px"
            imageMaxWidth={section.imageMaxWidth}
            textContent={
              <AppSectionText
                icon={section.icon}
                title={section.title}
                description={section.description}
                playStoreLink={section.playStoreLink}
                appStoreLink={section.appStoreLink}
                textAlign={section.textAlign}
              />
            }
          />
        ))}
      </div>

      {isLoggedIn && (
        <div className={` mx-auto `}>
          <DownloadSection
            title="Cut Sheet"
            description="Learn about 2.0 Mobile Applications features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="sgw-5d"
            showOnlyFirst={true}
          />
        </div>
      )}
    </div>
  );
};

export default MobileContent;
